import React from "react";
import { useDarkMode } from "../../App";
import HomePage from "../HomePage";

type AuthMode = "signin" | "signup";

type Props = {
  initialAuth?: AuthMode;
};

/**
 * Guest entry shell for /login and /signup. Renders the listing-first home
 * and lets HomePage open the shared guest auth modal.
 */
const LandingPage: React.FC<Props> = ({ initialAuth }) => {
  const { darkMode } = useDarkMode();
  return <HomePage darkMode={darkMode} initialAuth={initialAuth} />;
};

export default LandingPage;
